// extracted by mini-css-extract-plugin
module.exports = {"details":"ErrorBoundary_details__1Zdzb","message":"ErrorBoundary_message__30Hke","error-name":"ErrorBoundary_error-name__3_9fK"};